module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses = [];\nif(resourceData.isNew)          additionalClasses.push('isNew');\nif(resourceData.delete)         additionalClasses.push('delete');\nelse if (resourceData.renew)    additionalClasses.push('renew');\nelse if(resourceData.pause)     additionalClasses.push('pause');\nvar imageTitle = '';\nif(model.extendedButtonActionsGranted){\nimageTitle = '# ' + (resourceData.mediaID || '') + ' - ';\n}\nif(resourceData.missingMainDBEntry){\nimageTitle += __('error:imageManagement.missingMainDBEntry.title');\nadditionalClasses.push('missingMainDBEntry');\n} else {\nimageTitle += (resourceData.url || '');\n}\nvar imageWidth, imageHeight;\nvar resourceWidth = resourceData.preferredWidth || resourceData.width;\nvar resourceHeight = resourceData.preferredHeight || resourceData.height;\nif(resourceWidth && resourceHeight){\nif(resourceWidth > resourceHeight){\nimageWidth = model.maxImageWidth || 100;\nimageHeight = resourceHeight * imageWidth / resourceWidth;\n} else {\nimageHeight = model.maxImageHeight || 100;\nimageWidth = resourceWidth * imageHeight / resourceHeight;\n}\n} else {\nimageWidth = model.maxImageWidth || 100;\nimageHeight = model.maxImageHeight || 100;\n}\n%>\n<div class=\"<%- additionalClasses.join(' ') %>\" data-media-id=\"<%- resourceData.mediaID %>\" data-media-rendered-id=\"<%- resourceData.mediaRenderedID %>\" data-media-index=\"<%- resourceData.index %>\" title=\"<%= imageTitle %>\">\n<div class=\"new\">\n<i class=\"fi fi-image-new\"></i>\n</div>\n<div class=\"status\">\n<i class=\"pause fi fi-pause\"></i>\n<i class=\"renew fi fi-refresh\"></i>\n<i class=\"delete fi fi-trash\"></i>\n</div>\n<%\nvar controls = {\nedit: true,\nrenew: true,\ndelete: true,\nassignTags: true,\npause: true\n};\nif(resourceData.missingMainDBEntry){\ncontrols = { delete: true };\n} else {\nif(config.controls === false){\ncontrols = false;\n}\nelse {\nfor(var command in config.controls){\nif(config.controls[command] === false){\ncontrols[command] = false;\n}\n}\n}\n}\n// NOTE: usually no testing on urls is necessary - but the cms-should be robust and stable even in error cases.\nvar url     = resourceData.preferredUrl || resourceData.url || '';\nvar thumb   = resourceData.preferredThumb || resourceData.thumb || '';\nif(controls){\n%>\n<div class=\"controls\">\n<%\nif(controls.assignTags){\n%>\n<%- include('../../elements/buttons/default', { formMapping: { buttonType: 'showAssign',    context: 'tags',        mode: config.context, symbolOnly: true, icon: 'fi fi-mediaImageDetails' } }); %>\n<%\n}\nif(config.context === 'assignment' && controls.edit){\n%>\n<%- include('../../elements/buttons/default', { formMapping: { buttonType: 'showEdit',      context: 'media-image', mode: config.context, symbolOnly: true } }); %>\n<%\n}\nif(config.context === 'assignment' && controls.renew && model.extendedButtonActionsGranted){\n%>\n<%- include('../../elements/buttons/default', { formMapping: { buttonType: 'renew',         context: 'media-image', mode: config.context, symbolOnly: true } }); %>\n<%\n}\nif(config.context === 'assignment' && controls.pause){\n%>\n<%- include('../../elements/buttons/default', { formMapping: { buttonType: 'pause',        context: 'media-image', mode: config.context, symbolOnly: true } }); %>\n<%\n}\nif(controls.delete){\n%>\n<%- include('../../elements/buttons/default', { formMapping: { buttonType: 'delete',        context: 'media-image', mode: config.context, symbolOnly: true } }); %>\n<%\n}\n%>\n</div>\n<%\n}\nif(resourceData.missingMainDBEntry){\n%><i class=\"missingMainDBEntrySymbol fi fi-exclamation-triangle\" title=\"<%= imageTitle %>\"></i><%\n} else if(resourceData.fileType === 'file' && resourceData.extension) {\n%><i class=\"fi fi-media-<%= String(resourceData.extension).toLowerCase() %>\" title=\"<%= imageTitle %>\"></i><%\n} else {\n%><img title=\"<%= imageTitle %>\" alt=\"<%- resourceData.mediaID %>\" src=\"<%- thumb %>\" width=\"<%= imageWidth %>px\" height=\"<%= imageHeight %>px\"/><%\n}\nif(config.additionalDataInclusionTemplate){\n%><%- include(config.additionalDataInclusionTemplate, { resourceData: resourceData }) %><%\n}\n%>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/form/media/image/image.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses = [];
if(resourceData.isNew)          additionalClasses.push('isNew');
if(resourceData.delete)         additionalClasses.push('delete');
else if (resourceData.renew)    additionalClasses.push('renew');
else if(resourceData.pause)     additionalClasses.push('pause');
var imageTitle = '';
if(model.extendedButtonActionsGranted){
imageTitle = '# ' + (resourceData.mediaID || '') + ' - ';
}
if(resourceData.missingMainDBEntry){
imageTitle += __('error:imageManagement.missingMainDBEntry.title');
additionalClasses.push('missingMainDBEntry');
} else {
imageTitle += (resourceData.url || '');
}
var imageWidth, imageHeight;
var resourceWidth = resourceData.preferredWidth || resourceData.width;
var resourceHeight = resourceData.preferredHeight || resourceData.height;
if(resourceWidth && resourceHeight){
if(resourceWidth > resourceHeight){
imageWidth = model.maxImageWidth || 100;
imageHeight = resourceHeight * imageWidth / resourceWidth;
} else {
imageHeight = model.maxImageHeight || 100;
imageWidth = resourceWidth * imageHeight / resourceHeight;
}
} else {
imageWidth = model.maxImageWidth || 100;
imageHeight = model.maxImageHeight || 100;
}

    ; __line = 32
    ; __append("\n<div class=\"")
    ; __line = 33
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-media-id=\"")
    ; __append( resourceData.mediaID )
    ; __append("\" data-media-rendered-id=\"")
    ; __append( resourceData.mediaRenderedID )
    ; __append("\" data-media-index=\"")
    ; __append( resourceData.index )
    ; __append("\" title=\"")
    ; __append(escapeFn( imageTitle ))
    ; __append("\">\n<div class=\"new\">\n<i class=\"fi fi-image-new\"></i>\n</div>\n<div class=\"status\">\n<i class=\"pause fi fi-pause\"></i>\n<i class=\"renew fi fi-refresh\"></i>\n<i class=\"delete fi fi-trash\"></i>\n</div>\n")
    ; __line = 42
    ; 
var controls = {
edit: true,
renew: true,
delete: true,
assignTags: true,
pause: true
};
if(resourceData.missingMainDBEntry){
controls = { delete: true };
} else {
if(config.controls === false){
controls = false;
}
else {
for(var command in config.controls){
if(config.controls[command] === false){
controls[command] = false;
}
}
}
}
// NOTE: usually no testing on urls is necessary - but the cms-should be robust and stable even in error cases.
var url     = resourceData.preferredUrl || resourceData.url || '';
var thumb   = resourceData.preferredThumb || resourceData.thumb || '';
if(controls){

    ; __line = 68
    ; __append("\n<div class=\"controls\">\n")
    ; __line = 70
    ; 
if(controls.assignTags){

    ; __line = 72
    ; __append("\n")
    ; __line = 73
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'showAssign',    context: 'tags',        mode: config.context, symbolOnly: true, icon: 'fi fi-mediaImageDetails' } }) )
    ; __append("\n")
    ; __line = 74
    ; 
}
if(config.context === 'assignment' && controls.edit){

    ; __line = 77
    ; __append("\n")
    ; __line = 78
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'showEdit',      context: 'media-image', mode: config.context, symbolOnly: true } }) )
    ; __append("\n")
    ; __line = 79
    ; 
}
if(config.context === 'assignment' && controls.renew && model.extendedButtonActionsGranted){

    ; __line = 82
    ; __append("\n")
    ; __line = 83
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'renew',         context: 'media-image', mode: config.context, symbolOnly: true } }) )
    ; __append("\n")
    ; __line = 84
    ; 
}
if(config.context === 'assignment' && controls.pause){

    ; __line = 87
    ; __append("\n")
    ; __line = 88
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'pause',        context: 'media-image', mode: config.context, symbolOnly: true } }) )
    ; __append("\n")
    ; __line = 89
    ; 
}
if(controls.delete){

    ; __line = 92
    ; __append("\n")
    ; __line = 93
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'delete',        context: 'media-image', mode: config.context, symbolOnly: true } }) )
    ; __append("\n")
    ; __line = 94
    ; 
}

    ; __line = 96
    ; __append("\n</div>\n")
    ; __line = 98
    ; 
}
if(resourceData.missingMainDBEntry){

    ; __line = 101
    ; __append("<i class=\"missingMainDBEntrySymbol fi fi-exclamation-triangle\" title=\"")
    ; __append(escapeFn( imageTitle ))
    ; __append("\"></i>")
    ; 
} else if(resourceData.fileType === 'file' && resourceData.extension) {

    ; __line = 103
    ; __append("<i class=\"fi fi-media-")
    ; __append(escapeFn( String(resourceData.extension).toLowerCase() ))
    ; __append("\" title=\"")
    ; __append(escapeFn( imageTitle ))
    ; __append("\"></i>")
    ; 
} else {

    ; __line = 105
    ; __append("<img title=\"")
    ; __append(escapeFn( imageTitle ))
    ; __append("\" alt=\"")
    ; __append( resourceData.mediaID )
    ; __append("\" src=\"")
    ; __append( thumb )
    ; __append("\" width=\"")
    ; __append(escapeFn( imageWidth ))
    ; __append("px\" height=\"")
    ; __append(escapeFn( imageHeight ))
    ; __append("px\"/>")
    ; 
}
if(config.additionalDataInclusionTemplate){

    ; __line = 108
    ; __append( include(config.additionalDataInclusionTemplate, { resourceData: resourceData }) )
    ; 
}

    ; __line = 110
    ; __append("\n</div>")
    ; __line = 111
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/form/media/image/image.ejs

}